import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline:
          "text-foreground border-slate-200",
        active:
          "border-0 bg-emerald-600 text-white hover:bg-emerald-600",
        pending:
          "border-0 bg-amber-500 text-white hover:bg-amber-500",
        archived:
          "border-0 bg-slate-500 text-white hover:bg-slate-500",
        suspended:
          "border-0 bg-red-600 text-white hover:bg-red-600",
        clinicAdmin:
          "bg-violet-100 text-violet-800 border-violet-300",
        provider:
          "bg-emerald-100 text-emerald-800 border-emerald-300",
        staffPractitioner:
          "bg-amber-100 text-amber-800 border-amber-300",
        clinicStaff:
          "bg-sky-100 text-sky-800 border-sky-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
